import { render, staticRenderFns } from "./BowSelect.vue?vue&type=template&id=53e52d3c&"
import script from "./BowSelect.vue?vue&type=script&lang=js&"
export * from "./BowSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports